module.exports = require('./dist/InfiniteScroll')



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-infinite-scroller/index.js
// module id = 1166
// module chunks = 0